import { isObject } from 'lodash-es';

import { searchFilterActions } from '../panels/search_filters/actions';

const KEEPS_NATURAL_SEARCH = 'keepsNaturalSearch';

/**
 * Puts the words a natural search applied in the panel's query. Clearing the
 * query otherwise ends the natural search, but an answer that applied no words
 * (a browse by filters) is still that search's.
 */
export const setNaturalSearchPanelQuery = (query: string) => ({
  ...searchFilterActions.setQuery(query),
  meta: { [KEEPS_NATURAL_SEARCH]: true },
});

/** Whether an action is a natural search setting the panel's query. */
export const isNaturalSearchPanelQuery = (action: unknown): boolean =>
  isObject(action) &&
  'meta' in action &&
  isObject(action.meta) &&
  KEEPS_NATURAL_SEARCH in action.meta &&
  action.meta[KEEPS_NATURAL_SEARCH] === true;
